import { render, staticRenderFns } from "./ProductMallTable.vue?vue&type=template&id=5419e9b7&scoped=true&"
import script from "./ProductMallTable.vue?vue&type=script&lang=js&"
export * from "./ProductMallTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductMallTable.vue?vue&type=style&index=0&id=5419e9b7&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5419e9b7",
  null
  
)

export default component.exports